module.exports = __webpack_public_path__ + "static/media/FoodGuide.e51f7c8e.png";